import React from 'react';
import { Button } from './ui/Button';
export function FAQSection() {
  const faqs = [{
    q: '¿Sirve si soy recién recibida?',
    a: 'Sí. Los protocolos incluyen la lógica clínica detrás de cada decisión. Aplicás con confianza desde el día 1.'
  }, {
    q: '¿Sirve si ya tengo años de experiencia?',
    a: 'Especialmente para vos. El Pack no te enseña nutrición — ya la sabés. Te da el sistema operativo para que tu conocimiento se entregue de forma más eficiente y rentable.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'En menos de 5 minutos por email. Funciona en celular, tablet y computadora. Descarga inmediata.'
  }, {
    q: '¿Qué lo diferencia del material que encuentro online?',
    a: 'El material online es genérico y fragmentado. Este sistema está hecho para el consultorio argentino: las patologías más frecuentes acá, los alimentos que se consiguen acá, los precios del mercado argentino. Todo en un solo lugar.'
  }];
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-white text-black py-24 px-4" data-id="element-32">
      <div className="max-w-4xl mx-auto" data-id="element-33">
        <div className="text-center mb-16" data-id="element-34">
          <h2 className="font-display font-black text-4xl md:text-5xl uppercase mb-4" data-id="element-35">
            Lo que más nos preguntan
          </h2>
        </div>

        <div className="space-y-6 mb-24" data-id="element-36">
          {faqs.map((faq, i) => <div key={i} className="bg-gray-50 border border-gray-200 rounded-2xl p-6 md:p-8" data-id="element-37">
              <h3 className="font-display font-bold text-xl mb-3 text-brand" data-id="element-38">
                {faq.q}
              </h3>
              <p className="text-gray-700 text-lg" data-id="element-39">{faq.a}</p>
            </div>)}
        </div>

        {/* COST OF INACTION */}
        <div className="bg-black text-white rounded-3xl p-8 md:p-12 mb-24 shadow-2xl" data-id="element-40">
          <h3 className="font-display font-black text-3xl md:text-4xl uppercase text-center mb-10" data-id="element-41">
            ¿Cuánto cuesta no tenerlo?
          </h3>

          <div className="space-y-6" data-id="element-42">
            <div className="flex flex-col md:flex-row justify-between border-b border-zinc-800 pb-6" data-id="element-43">
              <div className="text-gray-400 font-bold uppercase mb-2 md:mb-0" data-id="element-44">
                SIN PACK NUTRICIÓN PRO
              </div>
              <div className="text-brand font-bold uppercase" data-id="element-45">COSTO REAL</div>
            </div>

            <div className="flex flex-col md:flex-row justify-between border-b border-zinc-800 pb-6" data-id="element-46">
              <div className="font-medium mb-2 md:mb-0" data-id="element-47">
                3 hs de planificación × 40 semanas
              </div>
              <div className="text-red-400 font-bold" data-id="element-48">
                120 horas de tu vida por año
              </div>
            </div>

            <div className="flex flex-col md:flex-row justify-between border-b border-zinc-800 pb-6" data-id="element-49">
              <div className="font-medium mb-2 md:mb-0" data-id="element-50">
                Sin material educativo
              </div>
              <div className="text-red-400 font-bold" data-id="element-51">
                20 min por consulta explicando lo mismo
              </div>
            </div>

            <div className="flex flex-col md:flex-row justify-between border-b border-zinc-800 pb-6" data-id="element-52">
              <div className="font-medium mb-2 md:mb-0" data-id="element-53">
                Sin protocolos patológicos
              </div>
              <div className="text-red-400 font-bold" data-id="element-54">
                Improvisando con patologías complejas
              </div>
            </div>

            <div className="flex flex-col md:flex-row justify-between pb-2" data-id="element-55">
              <div className="font-medium mb-2 md:mb-0" data-id="element-56">
                Domingo sin sistema
              </div>
              <div className="text-red-400 font-bold" data-id="element-57">
                El mismo ciclo exacto el próximo año
              </div>
            </div>
          </div>
        </div>

        {/* FINAL CTA */}
        <div className="text-center" data-id="element-58">
          <h2 className="font-display font-black text-4xl md:text-6xl uppercase mb-8" data-id="element-59">
            El próximo domingo puede ser diferente.
          </h2>
          <Button size="xl" onClick={scrollToPricing} className="mb-6" data-id="element-60">
            QUIERO MI PACK AHORA
          </Button>
          <p className="text-gray-500 font-medium" data-id="element-61">
            Pago 100% seguro · Acceso en 5 minutos · Garantía 7 días
          </p>
        </div>
      </div>
    </section>;
}